import { render, staticRenderFns } from "./photoAlbum.vue?vue&type=template&id=e4f33a6c&scoped=true"
import script from "./photoAlbum.vue?vue&type=script&lang=ts"
export * from "./photoAlbum.vue?vue&type=script&lang=ts"
import style0 from "./photoAlbum.vue?vue&type=style&index=0&id=e4f33a6c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f33a6c",
  null
  
)

export default component.exports